export enum AppMessages {
  btnLogIn = 'btn.logIn',
}

export type LocaleAppMessages = Record<AppMessages, string>;
